/**
 * @file
 * A JavaScript file for the site.
 */

// Modifying bio-accordion.js for use with insurance show/hide for FAD but made a little more portable so it could be used pretty much anywhere.
// show-hide structure should look like:
// <div class="show-hide__container">
//  <div class="show-hide__group">
//      <button aria-controls="content-div-id" class="show-hide__button button--secondary button--down-arrow">Show Hide Button</button>
//      <div id="content-div-id" class="show-hide__content typeset">
//          ... whatever content / html you want to show/hide ...
//      </div>
//  </div>
//  
//  <!-- NOTE: show more button is optional and will split after 10 show-hide__group -->
//  <button class="button-text show-hide__button--show-more">Show More Button</button>
// </div>

(function ($) {
    $('.show-hide__button').each(function () {
        $(this).click(function (e) {
            e.stopPropagation()
            $('.show-hide__button').removeClass('js-accordion-open');
            $('.show-hide__content').slideUp();

            if (
                $(this).siblings('.show-hide__content').is(':hidden') ==
                true
            ) {
                $(this).addClass('js-accordion-open');
                $(this).siblings('.show-hide__content').slideDown();
            }
            e.preventDefault();
        });
    });

    // Hide all show-hide text
    $('.show-hide__content').hide();

    $('.show-hide__container').each(function () {
        var showMoreBtn = $('.show-hide__button--show-more');
        var groups = $(this).children('.show-hide__group');
        var groupsNumber = groups.length;

        if (groupsNumber > 10) {
            showMoreBtn.fadeIn();
            groups.slice(10).addClass('hidden');
        } else {
            showMoreBtn.hide();
        }

        showMoreBtn.click(function (e) {
            if (groups.hasClass('hidden')) {
                groups.removeClass('hidden');
                showMoreBtn.toggleClass('isOpen');
                showMoreBtn.text('Show Less Options');
            } else {
                groups.slice(10).addClass('hidden');
                showMoreBtn.toggleClass('isOpen');
                showMoreBtn.text('Show More Options');
            }
            e.preventDefault();
        });
    });
}(jQuery));
